import * as React from 'react';

import ConsumerLoggedOutHomePageHeader from 'bundles/composable-page-header-consumer/header-renderers/ConsumerLoggedOutHomePageHeader';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';
import FrontPageGoogleSchemaMarkup from 'bundles/front-page/components/FrontPageGoogleSchemaMarkup';
import useScrollToTop from 'bundles/front-page/hooks/useScrollToTop';
import FrontPageContent from 'bundles/front-page/pages/FrontPageContent';
import { useAiAssistanceExperimentData } from 'bundles/front-page/providers/AiAssistanceExperimentProvider';
import FrontPageDataProvider from 'bundles/front-page/providers/FrontPageDataProvider';
import CoachChatContainer from 'bundles/front-page/redesign-modules/ai-assistance/CoachChatContainer';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import { useAiSearchExperimentData } from 'bundles/search-common/providers/AiSearchExperimentProvider';
import CourseraMetatags from 'bundles/seo/components/CourseraMetatags';

const FrontPageInner = () => {
  const { isAiAssistanceEnabled, isFirstTimeTrigger } = useAiAssistanceExperimentData();
  const { isVariant2 } = useAiSearchExperimentData();
  const headerRef = React.useRef<HTMLSpanElement>(null);

  useScrollToTop({ shouldScrollToTop: isFirstTimeTrigger });

  return (
    <React.Fragment>
      <span ref={headerRef}>
        <ConsumerLoggedOutHomePageHeader showSearch={!isVariant2} />
      </span>
      <UniversalPageFeatures />
      <FrontPageContent />
      {isAiAssistanceEnabled && <CoachChatContainer headerRef={headerRef} />}
      <PageFooter />
      <CourseraMetatags metaNameAndProperties={{ disableCourseraSuffix: true }} />
      <FrontPageGoogleSchemaMarkup />
    </React.Fragment>
  );
};

const FrontPage = () => {
  return (
    <FrontPageDataProvider>
      <FrontPageInner />
    </FrontPageDataProvider>
  );
};

export default FrontPage;
